<div>
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">
            Search User Requests
        </mat-card-title>
        <mat-card-content>
            <div class="search-container">
                <form [formGroup]="requestForm">
                    <div class="search-section">
                        <mat-form-field appearance="outline">
                            <mat-label>Resident Name</mat-label>
                            <input matInput formControlName="residentName" />
                        </mat-form-field>
              
                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Number</mat-label>
                            <input matInput formControlName="mobileNumber" maxlength="10" />
                        </mat-form-field>
              
                        <mat-form-field appearance="outline">
                            <mat-label>Area Name</mat-label>
                            <mat-select formControlName="areaName">
                                <mat-option *ngFor="let area of areas" [value]="area.value">
                                    {{ area.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        
                        <mat-form-field appearance="outline">
                            <mat-label>Request Status</mat-label>
                            <mat-select formControlName="requestStatus" multiple>
                                <mat-option *ngFor="let status of requestStatuses" [value]="status">
                                    {{ status }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
              
                    <div class="buttons">
                        <button mat-flat-button color="primary" (click)="onSearch()">Search</button>
                        <button mat-stroked-button color="warn" (click)="onReset()">Reset</button>
                    </div>
                </form>
            </div>          
        </mat-card-content>
    </mat-card>
</div>

<div style="margin-top: 25px;">
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">
            User Requests
        </mat-card-title>
        <mat-card-content>
            <div *ngIf="isLoading" class="loading-container">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
            <table mat-table [dataSource]="dataSource" matSort *ngIf="!isLoading">

                <!-- Resident Name Column -->
                <ng-container matColumnDef="residentName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Resident Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.residentName}} </td>
                </ng-container>

                <!-- Mobile Number Column -->
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.mobileNumber}} </td>
                </ng-container>

                <!-- Area Name Column -->
                <ng-container matColumnDef="areaName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Area Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.areaName}} </td>
                </ng-container>

                <!-- Area Name Column -->
                <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Block No / Qtr No </th>
                    <td mat-cell *matCellDef="let element"> {{ element.location }} </td>
                </ng-container>

                <!-- Area Name Column -->
                <ng-container matColumnDef="requestDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.requestDate | date: 'mediumDate' }} {{ element.requestDate | date: 'shortTime' }} </td>
                </ng-container>

                <!-- Request Status Column -->
                <ng-container matColumnDef="requestStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Status </th>
                    <td mat-cell *matCellDef="let element"> {{element.requestStatus}} </td>
                </ng-container>

                <!-- Department Name Column -->
                <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let element"> 
                        <button mat-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="onView(element)">
                                <mat-icon>visibility</mat-icon>
                                <span>View</span>
                            </button>
                            <button mat-menu-item *ngIf="element.requestStatus === 'PENDING'" (click)="onApprove(element)">
                                <mat-icon>check</mat-icon>
                                <span>Approve</span>
                              </button>
                            <button mat-menu-item *ngIf="element.requestStatus === 'PENDING'" (click)="onReject(element)">
                              <mat-icon>close</mat-icon>
                              <span>Reject</span>
                            </button>
                          </mat-menu>
                    </td>
                </ng-container>

                <!-- Header and Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <!-- Paginator -->
            <mat-paginator 
                [length]="dataSource.data.length" 
                [pageSize]="10" 
                [pageSizeOptions]="[5, 10, 20]" 
                showFirstLastButtons>
            </mat-paginator>
        </mat-card-content>
    </mat-card>
</div>
